import { render, staticRenderFns } from "./Piechart.vue?vue&type=template&id=16331ca7&scoped=true"
import script from "./Piechart.vue?vue&type=script&lang=js"
export * from "./Piechart.vue?vue&type=script&lang=js"
import style0 from "./Piechart.vue?vue&type=style&index=0&id=16331ca7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16331ca7",
  null
  
)

export default component.exports